var _path, _g, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgA7A5Tron({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 27,
    viewBox: "0 0 32 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6011_36616",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 27
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 0H0V26.1528H32V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6011_36616)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0764 25.8339C20.125 25.8339 25.8339 20.125 25.8339 13.0764C25.8339 6.02794 20.125 0.31897 13.0764 0.31897C6.02794 0.31897 0.31897 6.02794 0.31897 13.0764C0.31897 20.125 6.02794 25.8339 13.0764 25.8339Z",
    fill: "#F4B731"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6011_36616)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1184 10.2396H17.2924L17.9727 11.6215H14.8405L15.053 12.0608H18.1852L19.9994 15.7529H15.8396L15.1593 14.371H18.2703L17.8239 13.4569H14.7058L13.1184 10.2396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.21611 10.2466H4.52952L1.99963 15.7599H6.35075L5.79093 14.4843H4.33818L5.41534 12.2237L7.0098 15.7599L7.8531 13.8749L6.21611 10.2466Z",
    fill: "url(#paint0_linear_6011_36616)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9979 10.2466H11.3113L8.78143 15.7599H13.1325L12.5727 14.4843H11.12L12.1971 12.2237L13.7916 15.7599H15.7121L12.9979 10.2466Z",
    fill: "url(#paint1_linear_6011_36616)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3995 11.5222L6.83966 10.2466H11.1553L8.65382 15.7599H6.98139L8.88058 11.5151H7.3995V11.5222Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.5581 20.5182C28.6724 20.5182 32 17.1907 32 13.0764C32 8.9621 28.6724 5.63452 24.5581 5.63452C20.4438 5.63452 17.1163 8.9621 17.1163 13.0764C17.1163 17.1907 20.4438 20.5182 24.5581 20.5182Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5582 20.1993C28.4917 20.1993 31.6811 17.01 31.6811 13.0764C31.6811 9.14286 28.4917 5.95349 24.5582 5.95349C20.6246 5.95349 17.4352 9.14286 17.4352 13.0764C17.4352 17.01 20.6246 20.1993 24.5582 20.1993Z",
    fill: "#F3BA2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8252 12.3641L24.5581 10.6313L26.291 12.3641L27.301 11.3542L24.5581 8.62195L21.8259 11.3542L22.8252 12.3641ZM20.1036 13.0764L21.1136 12.0665L22.1236 13.0764L21.1136 14.0864L20.1036 13.0764ZM22.8252 13.7887L24.5581 15.5216L26.291 13.7887L27.301 14.7987L24.5581 17.5309L21.8259 14.7987L22.8252 13.7887ZM26.9927 13.0764L28.0026 12.0665L29.0126 13.0764L28.0026 14.0864L26.9927 13.0764ZM25.5787 13.0764L24.5581 14.097L23.5375 13.0764L23.7183 12.8957L23.8033 12.8107L24.5581 12.0558L25.5787 13.0764Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5581 20.5182C28.6724 20.5182 32 17.1907 32 13.0764C32 8.9621 28.6724 5.63452 24.5581 5.63452C20.4438 5.63452 17.1163 8.9621 17.1163 13.0764C17.1163 17.1907 20.4438 20.5182 24.5581 20.5182Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5582 20.1993C28.4917 20.1993 31.6811 17.01 31.6811 13.0764C31.6811 9.14286 28.4917 5.95349 24.5582 5.95349C20.6246 5.95349 17.4352 9.14286 17.4352 13.0764C17.4352 17.01 20.6246 20.1993 24.5582 20.1993Z",
    fill: "#EF0027"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9396 10.3549L20.5183 9.1748L23.899 17.6798L28.6087 11.9389L26.9396 10.3549ZM26.8333 10.8758L27.8113 11.8113L25.1216 12.3004L26.8333 10.8758ZM24.5475 12.1941L21.7196 9.84457L26.3549 10.6951L24.5475 12.1941ZM24.3456 12.6193L23.8884 16.4359L21.4007 10.1635L24.3456 12.6193ZM24.7708 12.8213L27.7475 12.2791L24.3349 16.4359L24.7708 12.8213Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6011_36616",
    x1: 1.99963,
    y1: 13.0033,
    x2: 7.8531,
    y2: 13.0033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#C10800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#CE2D0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D10000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6011_36616",
    x1: 8.78143,
    y1: 23.4063,
    x2: 15.7121,
    y2: 23.4063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#C10800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#CE2D0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D10000"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6011_36616"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(2 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA7A5Tron);
export default __webpack_public_path__ + "static/media/a7a5_tron.46a852635e3535ee0270e872cedb933c.svg";
export { ForwardRef as ReactComponent };